/** @ignore *//** */
const config = {
  version: '2.13.3',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts